export default {"src":"/_next/static/media/picture.eb00a74e.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};